import { Spinner } from "../misc"
import React from "react"
import clsx from "clsx"
import { ButtonType } from "./types"

export interface RegularButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  isSubmitting?: boolean
  disabled?: boolean
  isFormik?: boolean
  variant?: ButtonType
  textClassName?: string
  customPadding?: string
  customTextSize?: string
  rounded?: boolean
}

export const RegularButton: React.FC<RegularButtonProps> = ({
  isSubmitting,
  textClassName,
  children,
  variant = "solid",
  customPadding = "px-5 py-2",
  customTextSize = "text-sm sm:text-base",
  className,
  isFormik,
  disabled,
  rounded = false,
  ...props
}) => {
  let buttonStyle = ""

  switch (true) {
    case disabled:
      buttonStyle = "text-[rgba(58,53,65,0.26)] bg-[rgba(58,53,65,0.12)]"
      break
    case variant === "solid":
      buttonStyle = "text-white bg-green"
      break
    case variant === "transparent":
      buttonStyle = "text-green bg-transparent border-green border border-2"
      break
    case variant === "transparent-white":
      buttonStyle = "text-white bg-transparent border-white border border-2"
      break
    case variant === "transparent-blue":
      buttonStyle = "text-new-blue bg-transparent border-new-blue border border-2"
      break
    case variant === "transparent-red":
      buttonStyle = "text-red bg-transparent border-red border border-2"
      break
    case variant === "solid-blue":
      buttonStyle = "text-white bg-blue border-blue border border-2"
      break
    case variant === "new-blue":
      buttonStyle = "text-white bg-new-blue"
      break
    default:
      break
  }

  return (
    <button
      {...props}
      className={clsx(
        "relative flex items-center justify-center font-medium hover:shadow-[0_12px_32px_0px_rgba(0,0,0,0.2)]",
        "disabled:bg-grey-97 disabled:text-white disabled:cursor-not-allowed",
        !rounded && "rounded sm:font-semibold",
        buttonStyle,
        customPadding,
        customTextSize,
        className,
        rounded && "rounded-lg"
      )}
      disabled={disabled}
      type={isFormik ? "submit" : "button"}
    >
      {isSubmitting && <Spinner size="sm" className="" />}
      <span className={clsx(isSubmitting && "text-transparent", textClassName)}>{children}</span>
    </button>
  )
}
